<div class="modal-body p-0">
  @if (!businessObjectives.hideTop) {
    <div class="p-3 px-4 bg-light1">
      <p class="fs-15 text-info2 m-0">KPI</p>
      <p class="fs-15 m-0">{{businessObjectives?.kpi}}</p>
    </div>
  }

  @if (!businessObjectives.hideTop) {
    <div class="p-2 fs-15 mb-1">
      <p class="text-info2 mb-1">DESCRIPTION</p>
      <p class="mb-0" [innerHTML]="businessObjectives.desc" style="height: 100px; max-height: 100px; overflow-y:auto"></p>
    </div>
  }

  <div class="container-fluid">
    <div class="row px-3">
      @if (!businessObjectives.hideTop) {
        <div>
          <div class="d-flex">
            <div class="col-lg-4">
              <p class="fs-15 text-info2 mb-1 mt-3 mt-lg-0">SPONSOR</p>
              <div class="d-flex align-items-center mb-2">
                <img [src]="businessObjectives?.pics || '../../../../../../assets/images/public/default-avatar.png'"
                  alt="" class="me-3" width="50px" height="50px" appImageFallback
                  [fallbackSrc]="'../../../../../../assets/images/public/default-avatar.png'">
                  <p class="fs-15 m-0 ps-12" [innerHTML]="businessObjectives?.sponsor?.empName"></p>
                  <!-- <p class="fs-15 m-0 ps-12" [innerHTML]="businessObjectives?.OwnerName"></p> -->
                </div>
              </div>
              <div class="col-lg-4">
                <p class="fs-15 text-info2 mb-1 mt-3 mt-lg-0">OBJECTIVE REALISATION DATE</p>
                <div class="d-flex flex-wrap align-items-center mb-2">
                  <img src="../../../../../../../assets/images/uploads/calendar.svg" alt="" class=" py-2 me-3">
                  <p class="fs-15 m-0 ps-12">{{businessObjectives?.realisationDate | date: company?.display_date_format }}
                  </p>
                </div>
              </div>
              <div class="col-lg-4">
                <p class="fs-15 text-info2 mb-1 mt-3 mt-lg-0">TIME FRAME:
                  @if (businessObjectives?.time && businessObjectives?.timeUnit === 'year') {
                    <span class="fs-15 m-0 ps-12" style="color:black"
                      >
                    {{ businessObjectives.time }} ({{ businessObjectives?.timeUnit === 'year' ? businessObjectives?.timeUnit
                    :
                    ''}})
                  </span>
                }
                @if (businessObjectives?.time && businessObjectives?.timeUnit === 'month') {
                  <span class="fs-15 m-0 ps-12" style="color:black"
                    >
                    {{ businessObjectives.time }} ({{ businessObjectives.timeUnit === 'month' && businessObjectives?.time
                    ===
                    1 ? businessObjectives?.timeUnit : businessObjectives?.timeUnit + '(s)' }})
                  </span>
                }
              </p>
            </div>
          </div>
        <div class="col-lg-12 mt-2" style="max-height: 130px;
            overflow-y: auto; height: 130px">
            <p class="text-info2 mb-2 mb-xl-3 fs-15 mt-3  mt-xl-0">GOALS ({{businessObjectives?.goals.length}})</p>
            @for (obgoals of businessObjectives?.goals; track obgoals) {
              <div class="tags">
                <span class="goal-obj" [innerHTML]="Trimhtmltags(obgoals?.title)"></span>
              </div>
            }
          </div>
          <h2 class="tech-component"><span>TECHNOLOGY COMPONENT</span></h2>
        </div>
      }

      <div class="row">
        <div class="col-lg-3 fs-15 border-end">
          <p class="text-info2 mb-1 mb-xl-2 fs-15 mt-1  mt-xl-0">PROJECTS ({{businessObjectives.progs.length}})</p>
          <div class="tech-component-col">
            @for (obprogs of businessObjectives?.progs; track obprogs) {
              <div class="d-flex justify-content-between align-items-center py-2 border-bottom"
                >
                <p class="m-0 cursor-pointer" [innerHTML]="obprogs?.prgName" (click)="openProject(obprogs._id)"></p>
                @if (obprogs?.isRisk) {
                  <div class="">
                    <img src="/assets/images/uploads/alert.svg" alt="" class="me-1">
                  </div>
                }
              </div>
            }
          </div>
        </div>
        <div class="col-lg-3 fs-15 border-end">
          <div class="d-flex justify-content-between align-items-center">
            <p class="text-info2 mb-1 mb-xl-2 fs-15 mt-1  mt-xl-0">APPLICATIONS ({{businessObjectives.apps.length}})</p>
            <div class="fa-ta-switch">
              <span class="title"> FA </span>
              <span class="title"> TA </span>
            </div>
          </div>

          <div class="tech-component-col">
            @for (obapp of businessObjectives?.apps; track obapp) {
              <div class="d-flex justify-content-between align-items-center py-2 border-bottom"
                >
                <p class="m-0 cursor-pointer" [innerHTML]="obapp?.appName" (click)="openApplication(obapp._id)"></p>
                <div class="fa-ta-switch">
                  <span [style.background-color]="getFATAColor(obapp.faQusAvg)" class="switch1">
                  {{obapp.faQusAvg}}</span>
                  <span [style.background-color]="getFATAColor(obapp.taQusAvg)" class="switch1">
                  {{obapp.taQusAvg}}</span>
                </div>
              </div>
            }
          </div>
        </div>

        <div class="col-lg-3 fs-15 border-end">
          <p class="text-info2 mb-1 mb-xl-2 fs-15 mt-1  mt-xl-0">SUPPLIERS ({{businessObjectives.suppliers.length}})</p>

          <div class="tech-component-col">
            @for (obsupp of businessObjectives?.suppliers; track obsupp) {
              <div class="d-flex justify-content-between align-items-center py-2 border-bottom"
                >
                <p class="m-0 cursor-pointer" [innerHTML]="obsupp?.supplierName" (click)="openSupplier(obsupp._id)"></p>
                @if (obsupp?.isRisk) {
                  <div class="supplier-risk">
                    <img src="/assets/images/uploads/alert.svg" alt="" class="me-1">
                    <!-- <img src="../../../../../../../assets/images/uploads/i.svg" alt="" class="me-1" data-toggle="tooltip" data-placement="top"
                    title="{{obsupp.riskTooltip}}">  -->
                  </div>
                }
              </div>
            }
          </div>
        </div>

        <div class="col-lg-3 fs-15">
          <p class="text-info2 mb-1 mb-xl-2 fs-15 mt-1  mt-xl-0">OT ({{businessObjectives.ot?.length || 0}})</p>

          <div class="tech-component-col">
            @for (obot of businessObjectives?.ot; track obot) {
              <div class="d-flex justify-content-between align-items-center py-2 border-bottom"
                >
                <p class="m-0 cursor-pointer" [innerHTML]="obot?.assetName" (click)="openOT(obot._id)"></p>
                @if (obot?.isRisk) {
                  <div class="ot-risk">
                    <img src="/assets/images/uploads/alert.svg" alt="" class="me-1">
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>



    </div>
  </div>

</div>